exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spacer[data-v-c2696730]{padding:10px}.custom-border[data-v-c2696730]{border-style:solid;border-width:thin;padding-top:10px;padding-bottom:10px;margin-bottom:10px}.custom-float-right[data-v-c2696730]{float:right}", ""]);

// exports
